export const MAX_ITEMS_UNDER_ALL_RESULTS = 5;
